import "./_cadastro-2.scss";
import logoAbrafati from "../../assets/logo-abrafati.png";
import Input from "../../components/input/Input";
import Button from "../../components/button/button";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { DataRegistrationContext } from "../../contexts/contexts";

function Cadastro2() {
    const navigate = useNavigate();
    const brazilianStates = [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO",
    ];
    const [rgxValidatePhone, setRgxValidatePhone] = useState(false);
    const {
        company,
        setCompany,
        phone,
        setPhone,
        state,
        setState,
        company_role_id,
        setCompany_role_id,
    } = useContext(DataRegistrationContext);

    const [associateTypes, setAssociateTypes] = useState([]);

    useEffect(() => {
        setRgxValidatePhone(phone);
        fetch(`${process.env.REACT_APP_API_URL}/papeis-empresa`)
            .then((response) => response.json())
            .then((data) => {
                setAssociateTypes(data.data);
            })
            .catch((error) => console.error("Error fetching associate types:", error));
    }, []);

    function errorValueInput(index) {
        let spanRequired = document.querySelectorAll(".required");
        spanRequired[index].style.display = "block";
    }

    function validateValueInput(index) {
        let spanRequired = document.querySelectorAll(".required");
        spanRequired[index].style.display = "none";
    }

    function validadeName() {
        let nameEmpresa = document.querySelector("#empresa");
        setCompany(nameEmpresa.value);
        if (nameEmpresa.value.length === "" || nameEmpresa.value.length < 3) {
            errorValueInput(0);
        } else {
            validateValueInput(0);
        }
    }

    function validatePhone() {
        let alertPhone = document.querySelector(".alert-erro-phone");
        let phoneInput = document.querySelector("#telefone");
        let input = phoneInput;
        setPhone(phoneMask(input.value));
        var regexValidate = /^\([0-9]{2}\) [0-9]?[0-9]{4}-[0-9]{4}$/;

        if (regexValidate.test(phone)) {
            alertPhone.style.display = "none";
        } else {
            alertPhone.style.display = "block";
        }

        setRgxValidatePhone(regexValidate.test(phone));
    }

    const phoneMask = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "($1) $2");
        value = value.replace(/(\d)(\d{4})$/, "$1-$2");
        return value;
    };

    function onchangeInputState(e) {
        let alertState = document.querySelector(".alert-erro-state");
        setState(e.target.value);

        if (e.target.value !== "") {
            alertState.style.display = "none";
        }
    }

    function onchangeInputTypeAssociated(e) {
        let alertTypeAssociated = document.querySelector(".alert-erro-type-associated");
        setCompany_role_id(e.target.value);

        if (e.target.value !== "") {
            alertTypeAssociated.style.display = "none";
        }
    }

    function sendRegistrationData() {
        let alertState = document.querySelector(".alert-erro-state");
        let alertTypeAssociated = document.querySelector(".alert-erro-type-associated");

        validadeName();
        validatePhone();

        if (state === "") {
            alertState.style.display = "block";
        }

        if (company_role_id === "") {
            alertTypeAssociated.style.display = "block";
        }

        if (state === "" || company_role_id === "") return;
        if (company.length < 2) return;
        if (rgxValidatePhone === false) return;

        navigate("/cadastro3");
    }

    return (
        <section className="container-cadastro2">

            <div className='container-bg'></div>
            <div className="login__box-left">
                <h2 className="title">Cadastro</h2>

                <form className='cadastro__form'>
                    <div className="box-input">
                        <label className="label-select">Tipo de associado</label>
                        <select
                            className="container-select-type-associated"
                            onChange={(e) => onchangeInputTypeAssociated(e)}
                            value={company_role_id}
                            name="tipo-associado"
                            id="tipo-associado"
                        >
                            <option value="" disabled>
                                Selecione uma opção
                            </option>
                            {associateTypes.map((el) => (
                                <option key={el.id} value={el.id}>
                                    {el.name}
                                </option>
                            ))}
                        </select>
                        <p className="alert-erro-type-associated">
                            É necessário selecionar um tipo de associado
                        </p>
                    </div>

                    <Input
                        onChange={validadeName}
                        value={company}
                        text="É necessário registar um nome!"
                        type="text"
                        id="empresa"
                        label="Empresa"
                        placeholder="Digite o nome da sua empresa"
                    />

                    <div className="box-input">
                        <label className="label-select">Estado</label>
                        <select
                            className="container-select-state"
                            onChange={(e) => onchangeInputState(e)}
                            value={state}
                            defaultValue="0"
                            name="estado"
                            id="estado"
                        >
                            <option value="" selected disabled>
                                Selecione uma opção
                            </option>
                            {brazilianStates.map((el) => (
                                <option key={el} value={el}>
                                    {el}
                                </option>
                            ))}
                        </select>
                        <p className="alert-erro-state">
                            É necessário selecionar um estado
                        </p>
                    </div>

                    <Input
                        onChange={validatePhone}
                        value={phone}
                        type="tel"
                        maxLength="15"
                        id="telefone"
                        label="Telefone"
                        placeholder="Digite seu telefone"
                    />
                    <p className="alert-erro-phone">
                        Digite um telefone válido, com DDD da operadora e seu
                        número!
                    </p>
                    <Button onClick={sendRegistrationData} type="button">
                        Avançar
                    </Button>
                </form>

                <Link className="btn-back" to="/cadastro">
                    Voltar
                </Link>

                <img
                    className="logo-abrafati"
                    src={logoAbrafati}
                    alt="logomarca Abrafati"
                />
            </div>
        </section>
    );
}

export default Cadastro2;
